<div class="container mt-5 text-center">
  <!-- 404 -->
  <ng-container *ngIf="statusCode === 404">
    <h1 class="display-4 text-warning">404 - Page Not Found</h1>
    <p class="lead mt-4">The page you are looking for does not exist or has been moved.</p>
  </ng-container>

  <!-- 500 -->
  <ng-container *ngIf="statusCode === 500">
    <h1 class="display-4 text-danger">500 - Server Error</h1>
    <p class="lead mt-4">{{ message }}</p>
  </ng-container>

  <!-- Generic -->
  <ng-container *ngIf="statusCode !== 404 && statusCode !== 500">
    <h1 class="display-4 text-danger">{{ statusCode || 'Error' }}</h1>
    <p class="lead mt-4">{{ message }}</p>
  </ng-container>

  <hr />
  <p *ngIf="path" class="text-muted"><small>Error at: {{ path }}</small></p>
  <p>Please try again later or contact your system administrator.</p>

  <button class="btn btn-primary mt-3" (click)="goHome()">
    <i class="fas fa-home"></i> Return to Home
  </button>
</div>